import React, { useEffect, useRef, useState } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import PropTypes from "prop-types";

export default function BFormSelectInput({
  placeholder,
  fieldName,
  control,
  options,
  multi
}) {
  const [selectValue, setSelectValue] = useState({});
  const inputRef = useRef();
  useEffect(() => {
    inputRef.current.onChange(getPreloadedDataFromControl());
  }, [setSelectValue, options]);

  const handleInputChange = (e) => {
    if (e == null) {
      return null;
    }
    if(multi){
      setSelectValue(e);
      return e.map((el) => el.value);
    }
    else{
      setSelectValue(e);
      return e.value;
    }
    
  };
  const getPreloadedDataFromControl = () => {
    if(!options) return;
    if(multi)
      return control.defaultValuesRef &&
        control.defaultValuesRef.current[`${fieldName}`]
        ? options.filter(
            (o) => control.defaultValuesRef.current[`${fieldName}`].some(s => s.name === o.label)
          )
        : [];
    else
      return control.defaultValuesRef &&
        control.defaultValuesRef.current[`${fieldName}`]
        ? options.find(
            (o) => o.label === control.defaultValuesRef.current[`${fieldName}`]
          )
        : "";
  };

  const splitFieldName = () => {
    const result = fieldName.replace(/([A-Z])/g, " $1");
    return result.toLowerCase();
  };

  return (
    <div>
      <Controller
        control={control}
        name={fieldName}
        rules={{ required: true }}
        render={({ field: { onChange } }) => (
          <Select
            onChange={(e) => onChange(handleInputChange(e))}
            placeholder={placeholder}
            options={options}
            ref={inputRef}
            isMulti={multi}
            value={selectValue}
            noOptionsMessage={() =>
              `No one ${splitFieldName()} match to serach phrase.`
            }
          />
        )}
      />
    </div>
  );
}

BFormSelectInput.propTypes = {
  placeholder: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.isRequired,
    })
  ),
};
